import Rest from '../rest'

/******************************************************************************
 *  Tasks
 *****************************************************************************/

/**
 * @type {Task}
 */
export default class Task extends Rest {

    constructor () {
        super('/task')
    }

    toggle(id, data){
        return this.http.put(this.constructor.normalize(this.resource, id), data )
    }

    getData(url, params) {
        return this.getAll(url, params)
            .then((response) => {
                const data = response.data.map((item) => {
                    if (item.linked) {
                        item.deal_number = item.linked.deal_id ? item.linked.deal_id : 'Não informado'
                        item.client_name = item.linked.customer ? item.linked.customer.name : ''
                    } else {
                        item.deal_number = 'Não informado'
                        item.client_name = ''
                    }
                    return item
                })
                response.data = data
                return response
            })
    }

    readFilters() {
        return this.http.get(this.constructor.normalize(this.resource, 'types'))
            .then((response) => {
                let data = response.data[0].fields.map((item) => {
                    item.text = item.label
                    item.id = item.value
                    return item
                })
                response.data = data
                return response
            });
    }
}